/**
 * Опции нативного <select> с группировкой по командам (<optgroup>).
 *
 * Для одиночного выбора сотрудника (ответственный Проекта, «Исполнитель»
 * расхода) нативный select лучше своего пикера: на телефоне это системное
 * колесо, а optgroup даёт ту же структуру «команда → люди», что и экран
 * «Сотрудники». Без команд — плоский список по имени, как раньше.
 *
 *   <select …>
 *     <option value="">…</option>
 *     <TeamGroupedOptions users={users} teams={teams} current={{ id, name }} />
 *   </select>
 *
 * current — уже выбранный человек, которого нет в списке (отключён или вне
 * области): без отдельной опции select молча показал бы пустое значение.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { groupMembersByTeam } from '../utils/teamGrouping';

export default function TeamGroupedOptions({ users = [], teams = [], current = null }) {
  const { t } = useTranslation();
  const missing = current && current.id && !users.some((u) => u.id === Number(current.id))
    ? <option key={`cur-${current.id}`} value={current.id}>{current.name || `#${current.id}`}</option>
    : null;

  if (!teams.length) {
    const sorted = [...users].sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'ru'));
    return <>{missing}{sorted.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}</>;
  }

  const { none, sections } = groupMembersByTeam(users, teams, '');
  return (
    <>
      {missing}
      {sections.filter((s) => s.rows.length).map((s) => (
        <optgroup key={s.team.id} label={s.team.name}>
          {s.rows.map(({ m }) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </optgroup>
      ))}
      {none.length > 0 && (
        <optgroup label={t('teams.noTeamSection')}>
          {none.map(({ m }) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </optgroup>
      )}
    </>
  );
}
